import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap
		//hero
		let $newsCatWrap = $('.news-cat-wrap')[0]
		if ($newsCatWrap) {
			gsap.fromTo(
				'.news-cat-wrap',
				{
					x: -50,
					opacity: 0,
				},
				{
					scrollTrigger: '.news-cat-wrap',
					delay: 0.5,
					duration: 0.25,
					x: 0,
					opacity: 1,
				}
			)
		}

		// planes
		let $planes = $('.sen-item-wrap .coastal-text-media-block .white-line svg')
		if ($planes.length) {
			document
				.querySelectorAll(
					'.sen-item-wrap .coastal-text-media-block .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: -20 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							y: 75,
						}
					)
				})
		}

		//coastal text & media block
		let $MediaBlock = $('.sen-item-wrap .coastal-text-media-block')
		if ($MediaBlock.length) {
			document
				.querySelectorAll('.sen-item-wrap .coastal-text-media-block')
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}

		//pagination
		let $pagination = $('.pagination')[0]
		if ($pagination) {
			gsap.fromTo(
				'.pagination',
				{
					y: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.pagination',
					delay: 0.25,
					duration: 0.25,
					y: 0,
					opacity: 1,
				}
			)
		}
	},
}
